import React, { useState } from "react";
import { SHARED_ICONS } from "../../theme";
import Chip from '@mui/material/Chip';
import DangerousIcon from '@mui/icons-material/Dangerous';
import { LoadingOutlined } from "@ant-design/icons";
import {  Upload } from "antd";
import { getFullFaceDescription } from "../../faceUtil";
import { inputSize } from "../../globalData";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { MatButton } from "../../components/elements";



function getBase64(file) {
   return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
   });
}

function UploadFromDisk({
   addFacePhotoCallback,
   isSubmitting
   // countRefetch,
   // loading,
}) {



   const [previewVisible, setPreviewVisible] = useState(false);
   const [fullDesc, setFullDesc] = useState([]);
   const [faceDescriptor, setFaceDescriptor] = useState([]);
   const [previewImage, setPreviewImage] = useState("");
   const [previewTitle, setPreviewTitle] = useState("");
   const [isRunningFaceDetector, setIsRunningFaceDetector] = useState(false);
   const [detectionCount, setDetectionCount] = useState(0);

   const [fileList, setFileList] = useState([]);
   const handleCancel = () => setPreviewVisible(false);

   const handlePreview = async (file) => {
      setPreviewVisible(true);
      setPreviewTitle( file.name || file.url.substring(file.url.lastIndexOf("/") + 1));
   };

   const handleChange = async ({ fileList }) => {
      if (fileList.length === 0) {
         setFaceDescriptor([]);
         setDetectionCount(0);
         setFileList([]);
         return;
      }

      if (!fileList[0].url && !fileList[0].preview) {
         if (/\.(jpe?g|png)$/i.test(fileList[0].name) === false) {
            alert("Not an image file (only JPG/JEPG/PNG accepted)!");
            return;
         }
         fileList[0].preview = await getBase64(fileList[0].originFileObj);
      }
      setPreviewImage(fileList[0].url || fileList[0].preview);
      setFileList(fileList);

      if (fileList[0].preview.length > 0) {
         setIsRunningFaceDetector(true);
         await getFullFaceDescription(fileList[0].preview, inputSize).then((data) => {
            setFullDesc(data);
            setDetectionCount(data.length);
            setFaceDescriptor(data[0].descriptor);
            setIsRunningFaceDetector(false);
         }
         );
      }
   };

   const handleSubmit = () => {
      if (previewImage.length > 0 && faceDescriptor.length === 128) {
         addFacePhotoCallback({ photoData: previewImage, faceDescriptor: faceDescriptor.toString() });
      }
   };


   return (
      < >

         <div className="disk-upload-box" style={{ textAlign: 'center' }}>
            <Upload
               beforeUpload={() => false}
               multiple={false}
               listType="picture-card"
               onPreview={handlePreview}
               onChange={handleChange}
               accept="image/x-png,image/jpeg"
               fileList={fileList}
               className="upload-btn-disk"
            >
               {fileList.length >= 1 ? null : (
                  <div style={{ fontSize: '16px' }}>
                     {SHARED_ICONS.FaUpload}
                     <div style={{ marginTop: 8, fontWeight: 600 }}>Choose</div>
                  </div>
               )}
            </Upload>

         </div>

         <div className="face-stats">
            {fileList?.length > 0 && (
               <>
                  {isRunningFaceDetector ? (<p>Detecting face... <LoadingOutlined /></p>) : (
                     <>
                        {detectionCount === 0 ? (<Chip icon={<DangerousIcon />} label="No face detected" variant="outlined" />) : (
                           <>
                              <p>Number of face detected:{detectionCount}</p>
                              {detectionCount > 1 && (
                                 <Chip color="error" icon={<DangerousIcon />} label="Only single face allowed" variant="outlined" />
                              )}
                           </>
                        )}
                     </>
                  )}
               </>
            )}
         </div>
         <div className="btn-submit">
            <MatButton
               onClick={handleSubmit}
               disableElevation
               className="save-btn"
               btnText={isSubmitting ? "Please wait" : "Upload"}
               endIcon={isSubmitting ? null : <CloudUploadIcon />}
               disabled={previewImage.length === 0 || isSubmitting || detectionCount !== 1 || faceDescriptor.length !== 128}
               isLoading={isSubmitting}
            />



         </div>

         <Dialog
            open={previewVisible}
            fullWidth
            maxWidth={'sm'}
            onClose={handleCancel}
         >
            <DialogContent>
               <img alt="example" style={{ width: "100%" }} src={previewImage} />
            </DialogContent>
         </Dialog>
      </>
   );
}

export default UploadFromDisk;
